module.exports = __webpack_public_path__ + "static/media/strawberry_compote.ead77271.png";